import { createI18n } from 'vue-i18n';
import i18nDateTimeEnglish from '@i18n/datetime/en.json';
import i18nDateTimeEnglishGB from '@i18n/datetime/en-gb.json';
import i18nEnglish from '@i18n/en.json';
import i18nNumberEnglish from '@i18n/number/en.json';

export default createI18n({
    datetimeFormats: {
        en: i18nDateTimeEnglish as Record<string, Record<string, string | boolean | number>>,
        'en-gb': i18nDateTimeEnglishGB as Record<string, Record<string, string | boolean | number>>
    },
    fallbackLocale: 'en',
    legacy: false,
    locale: navigator.language.toLocaleLowerCase(),
    messages: {
        en: i18nEnglish,
        'en-gb': i18nEnglish
    },
    numberFormats: {
        en: i18nNumberEnglish as Record<string, Record<string, string | boolean | number>>,
        'en-gb': i18nNumberEnglish as Record<string, Record<string, string | boolean | number>>
    }
});
